import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="w-full bg-white py-4 px-6 shadow-sm">
      <div className="max-w-7xl mx-auto flex items-center justify-center">
        <img 
          src="/assets/logo-streetvape-nubes.png" 
          alt="Street Vape Clouds Logo" 
          className="h-12 w-auto"
        />
      </div>
    </header>
  );
}

export default Header;